<template>
<div class="navbar" :class="'bg-'+this.theme.navbarColor">
  <div class="navbar-branding">
    <logo></logo>
  </div>
  <breadcrumb></breadcrumb>
  <ul class="nav navbar-nav navbar-right clearfix">
      <li v-if="this.$store.getters.orgId === 2">
        <a class="navbar_icon" title="数据可视化" @click='dataVisualization'>
          <i class="icon-keshihuashujuETL"></i>
        </a>
      </li>    
      <li>
        <a class="navbar_icon" title="全屏" @click='toggleFullScreen'>
          <i class="icon-weibiaoti2"></i>
        </a>
      </li>
      <li>
        <a class="navbar_icon" title="主题颜色">
           <el-popover  placement="bottom" width="200" trigger="click">
              <SkinToolbox></SkinToolbox>
              <i slot="reference" class="icon-theme"></i>
            </el-popover>
        </a>
      </li>
      <li class="account-info">
        <cx-dropdown placement="bottom-end" trigger="click">
          <a class="navbar_icon">
            <div style="vertical-align: middle;line-height: 49px;">
              <i class="icon-gerentouxiang" style="font-size:22pt!important;padding-right:2px;"></i>
              <span style="font-size: 14px">{{userName}}</span>
          </div>
          </a>
          <cx-dropdown-menu slot="list" clickHide>
            <pop-account :profile="profile"></pop-account>
          </cx-dropdown-menu>
        </cx-dropdown>

     </li>
      <li class="logout">
        <cx-dropdown placement="bottom-end" trigger="click" @on-click="clickShutDown">
          <a class="navbar_icon">
            <i class="icon-guanji"></i>
          </a>
          <cx-dropdown-menu slot="list" on>
              <cx-dropdown-item divided name="layout"><i class="icon-guanji"></i>注销</cx-dropdown-item>
          </cx-dropdown-menu>
        </cx-dropdown>
      </li>
  </ul>
  <!-- 常用菜单设置 -->
</div>
</template>
<script>
import { mapGetters } from 'vuex'
import logo from './logo'
import CxDropdown from '@/components/Dropdown'
import CxDropdownMenu from '@/components/DropdownMenu'
import CxDropdownItem from '@/components/DropdownItem'
import Breadcrumb from '@/components/Breadcrumb'
import screenfull from 'screenfull'
import PopAccount from './PopAccount'
import SkinToolbox from '../SkinToolbox'
import { openWindow } from '@/utils/assist'

export default {
  components: { logo, CxDropdown, CxDropdownMenu, CxDropdownItem, PopAccount, Breadcrumb, SkinToolbox },
  props: {},
  data() {
    return {
      platformNameLogo: {
        name: '',
        logo: ''
      }
    }
  },
  mounted: function() {
  },
  computed: {
    ...mapGetters([
      'theme',
      'alarms',
      'profile',
      'addRouters',
      'userName'
    ])
  },
  methods: {
    clickShutDown(name) {
      switch (name) {
        case 'layout':
          this.$confirm('确定要退出登录吗？', '退出确认', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$store.dispatch('LogOut').then(() => {
              window.location.reload(true)
            })
          })
          break
        default:
          break
      }
    },
    selectedMenu: function(currentMenu) {
      return this.activedMenu === currentMenu
    },
    toggleFullScreen() {
      if (!screenfull.enabled) {
        this.$message({
          message: '您的浏览器不支持',
          type: 'warning'
        })
        return false
      }
      screenfull.toggle()
    },
    dataVisualization() {
      openWindow(this.$router, '/visualization/gqVisualization')
    }
  }
}
</script>
<style lang="scss" scoped>
 .assit_title{
   font-size:14px;color:#C0C4CC
 }
 .shortcut_choose {
   min-height:150px;
   text-align:left;margin-left:20px;border-right:1px solid #e7e7e7;
   > .el-checkbox:not(:first-child){
     margin-left:0px
   }
 }
 .el-row{
     margin-top:20px;
     &:last-child{
       margin-bottom:20px
     }
 }
 .ivu-dropdown-item-divided::before{
   background-color: white;
   height: 0px;
 }
</style>
<style lang="scss">
.logout{
  .ivu-select-dropdown{
    padding: 5px 0px 0px 0px;
    background-color: white;
    &:hover{
      background-color: #f3f3f3;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/views/layout/components/Navbar/index.vue